import { Typography, List, Card, CardHeader, Box, ListItemButton } from '@mui/material';
import { NearestSalesPoint } from 'orderme-api-integration-client';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { appStyleMode } from '../../helpers/clientConfigs';
import { AppStyle } from '../../helpers/appStyle';
import { PointInfo } from './pointInfo';
import { useState } from 'react';
import { useRouteNavigator } from '../../routes/useRouteNavigator';

interface ChoosePointsProps {
  filteredDeliveryDetails: NearestSalesPoint[];
  expanded?: boolean;
}

export function ChoosePoints(props: ChoosePointsProps) {
  const { filteredDeliveryDetails, expanded = false } = props;
  const [selectedSalesPoint, setSelectedSalesPoint] = useState<NearestSalesPoint>();
  const routeNavigator = useRouteNavigator();

  const clickPoint = (point: NearestSalesPoint) => {
    if (appStyleMode === AppStyle.Mobile) {
      routeNavigator.goToSalesPoint({ state: point });
    } else {
      if (selectedSalesPoint !== point) {
        setSelectedSalesPoint(point);
      } else {
        setSelectedSalesPoint(null);
      }
    }
  };

  return (
    <>
      <List className={appStyleMode === AppStyle.Mobile ? 'sales-points-list' : null}>
        {filteredDeliveryDetails?.map((deliveryOption, index) => {
          return (
            <Box sx={{ px: '16px', py: '5px' }} key={index}>
              <ListItemButton
                sx={{ p: '0px', cursor: expanded && 'default' }}
                onClick={() => clickPoint(deliveryOption)}
              >
                <Card
                  sx={{
                    width: '100%',
                    borderRadius: deliveryOption === selectedSalesPoint ? '4px 4px 0px 0px' : '4px',
                  }}
                >
                  <CardHeader
                    title={
                      <Box
                        sx={{
                          display: 'grid',
                          gridTemplateColumns: 'auto auto',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Box>
                          <Typography>
                            {deliveryOption.value.name}, {deliveryOption.value.city}
                          </Typography>
                          <Typography sx={{ fontSize: '12px' }}>{deliveryOption.value.address}</Typography>
                        </Box>
                        {deliveryOption !== selectedSalesPoint && !expanded && (
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              fontSize: '30px',
                            }}
                          >
                            {deliveryOption.distanceInMeters && (
                              <Typography sx={{ color: '#1f4a8f' }}>
                                {(deliveryOption.distanceInMeters / 1000).toFixed(2)}
                                km
                              </Typography>
                            )}
                            <ArrowForwardIosIcon sx={{ color: '#dbdbdb', height: '17px' }} />
                          </Box>
                        )}
                      </Box>
                    }
                  />
                </Card>
              </ListItemButton>
              {(deliveryOption === selectedSalesPoint || expanded) && <PointInfo salesPoint={deliveryOption} />}
            </Box>
          );
        })}
      </List>
    </>
  );
}
